import { Button } from "components/DesignSystem/Button/Button";
import { useToast } from "hooks/useToast";
import { useToggleChannelFrozenMutation } from "store/apis/chat";
import { useGetTaskFromChannelIdQuery } from "store/apis/task";
import { useChannelStateContext } from "stream-chat-react";

export const ChannelFrozenBlocker = () => {
  const { channel } = useChannelStateContext();
  const channelId = channel?.id;
  const isFrozen = channel?.data?.frozen;
  const { successToast } = useToast();

  const [updateChannelFrozen, { isLoading: isLoadingFrozen }] =
    useToggleChannelFrozenMutation();

  const { data: channelTask } = useGetTaskFromChannelIdQuery(
    {
      channelId: channelId!,
    },
    {
      skip: !channelId,
    }
  );

  const toggleChannelFrozen = async () => {
    try {
      if (channelId) {
        await updateChannelFrozen({
          channelId,
        }).unwrap();
        successToast({
          title: "Channel update",
          message: `Channel marked as ${isFrozen ? "unfrozen" : "frozen"}.`,
        });
      }
    } catch (e: any) {
      alert(e?.data?.error?.message);
    }
  };

  const { tasks } = channelTask || {};
  const task =
    tasks?.find((task) => task.is_parent_task) || tasks?.[1] || tasks?.[0];

  return (
    <div className="t-flex t-flex-col t-mb-8 t-gap-0.5">
      <div className="t-flex t-gap-6 t-px-3 t-items-center">
        <hr className="t-bg-[var(--str-chat\_\_date-separator-line-color)] t-flex-1 t-border-none t-h-px t-m-0" />
        <span className="t-text-subtext t-text-text-60">
          Chat has been archived
        </span>
        <hr className="t-bg-[var(--str-chat\_\_date-separator-line-color)] t-flex-1 t-border-none t-h-px t-m-0" />
      </div>

      {task ? (
        <p className="t-m-0 t-text-text-30 t-text-body-sm t-text-center">
          We've closed this chat since the task {channel.data?.name} is
          archived. Still have questions or need clarity?
        </p>
      ) : (
        <p className="t-m-0 t-text-text-30 t-text-body-sm t-text-center">
          You can no longer send messages in this channel
        </p>
      )}

      <div className="t-flex t-justify-center t-mt-3">
        <Button
          onClick={toggleChannelFrozen}
          disabled={isLoadingFrozen}
          isLoading={isLoadingFrozen}
          size="small"
        >
          Reopen chat
        </Button>
      </div>
    </div>
  );
};
